import React from "react";
import vid from "../../../assets/vid/vid1.mp4";

const MainHero = () => {
  return (
    <div className="relative h-screen w-full overflow-hidden">
      {/* Background video */}
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src={vid} // Replace with your gym video URL
        autoPlay
        loop
        muted
      ></video>

      {/* Dark overlay */}
      <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-4">
        <h1 className="text-4xl md:text-6xl font-bold mb-4 uppercase">
          Silniejszy każdego dnia
        </h1>
        <p className="text-lg md:text-xl mb-8">Uwolnij swój potencjał</p>
        <a
          className="bg-orange-500 text-white px-6 py-3 rounded-xl font-semibold hover:bg-orange-600 transition duration-300"
          href="/pierwsza-wizyta"
        >
          Umów się na pierwszy trening
        </a>
      </div>
    </div>
  );
};

export default MainHero;
